import React, { useRef, useEffect, useState } from 'react';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import { isClientEnv } from '@app/src/utils/validations';
import { useSelector, useDispatch } from 'react-redux';
import { formatPrice } from '@app/src/utils/normalize';
import {
  clearPhotoVignette,
  postPhotoVignette,
  selectExtracharge,
  TypePublicationModel
} from '@app/src/views/StepTwo/channelPublication';
import {
  Multimedia,
  Uploader,
  TextButton,
  Price,
  IconCloseWrapper,
  Loading,
  ImagePreview,
  ErrorMessage,
  Info
} from './styled';

interface Props {
  colorTheme?: string;
  channelId?: number;
  isShowIconClose?: boolean;
  height?: string;
  available?: number;
  isDisabled?: boolean;
  imageDefault?: any;
}

const PHOTO_VIGNETTE_ALIAS: string = 'fotovineta';
const isClient: Boolean = isClientEnv();
const MAX_SIZE: number = 4194304;
const PHOTO_VIGNETTE = {
  MIN_WIDTH: 445,
  MIN_HEIGHT: 236
};

export const MultimediaUpload: React.FC<Props> = ({
  colorTheme,
  isShowIconClose,
  height,
  isDisabled,
  imageDefault
}) => {

  const dispatch = useDispatch();
  const refWrapper = useRef(null);
  const refImage = useRef(null);

  const [errorMessage, setErrorMessage] = useState('');
  const [pricePhotoVignette, setPricePhotoVignette] = useState(null);
  const [isShowImage, setIsShowImage] = useState(false);
  const [isActionUpload, setIsActionUplod] = useState(false);

  const isFetching = useSelector(state => state.photoVignette.isFetching);
  const currentChannel: TypePublicationModel = useSelector(state => state.typePublication.selected);
  const channelId = currentChannel && currentChannel.id;
  const newspaperId = currentChannel && currentChannel.newspaperId;
  const extracharges = useSelector(state => state.extracharge.data);
  const currentExtracharge = extracharges && extracharges[channelId] && extracharges[channelId].data;
  const categoryId = useSelector(state => state.print.general.category);
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const currentPrintsChannel = printsByChannel && printsByChannel[channelId];
  const typeUserAction = useSelector(state => state.session.user.pasarella);
  const photoVignetteData = useSelector(state => state.photoVignette.data)
  const photoVignetteChannel = photoVignetteData && photoVignetteData[channelId];
  const currentPhotoVignette = photoVignetteChannel && photoVignetteChannel.urlImage;
  const currentExtra = currentExtracharge && currentExtracharge.filter(item => item.alias === 'fotovineta')[0];
  const currentPrints = currentPrintsChannel && currentPrintsChannel.length || 0;
  const counter = useSelector(state => state.myPackageAvailable.counter);
  const counterBoth = counter && counter.both;

  useEffect(() => {
    if (currentPhotoVignette || imageDefault) {
      setIsShowImage(true);
    }

    if (currentPhotoVignette && isActionUpload) {
      setIsActionUplod(false);
      setExtrachargeByNewspaper(currentExtra, true, currentExtra.quantity - currentPrints);
    }
  }, [currentPhotoVignette, isActionUpload, imageDefault]);

  useEffect(() => {
    if (extracharges && extracharges[channelId] && extracharges[channelId].data) {
      const position = extracharges[channelId].data.map((item) => { return item.alias; }).indexOf(PHOTO_VIGNETTE_ALIAS);
      const price = formatPrice(currentExtracharge && currentExtracharge[position] && currentExtracharge[position].price);
      setPricePhotoVignette(price);
    }
  }, [extracharges]);

  const handleClickClearImage = () => {
    dispatch(clearPhotoVignette(channelId));
    setIsShowImage(false);
    if (currentExtra) {
      if (typeUserAction === 'consume-print') {
        setExtrachargeByNewspaper(currentExtra, false, currentExtra.quantity + currentPrints);
      } else {
        dispatch(selectExtracharge(channelId, currentExtra.extrachargeId, false));
      }
    }
  };

  const getValidDimensionImage = async (currentFile) => {
    setErrorMessage('')
    if (typeUserAction === 'consume-print') {
      const currentPrints = printsByChannel[channelId].length;
      const photoVignette = currentExtracharge.filter(item => item.alias === 'fotovineta')[0];

      if (currentPrints > (photoVignette && photoVignette.quantity)) {
        setErrorMessage('Extracargos insuficientes. Recuerde consume un extracargo por cada fecha seleccionada');
        return true;
      }
    }
    if (!(currentFile.type === 'image/jpeg' || currentFile.type === 'image/png')) {
      setErrorMessage('Formato permitido: jpeg, png');
      return true;
    }
    if (currentFile.size > MAX_SIZE) {
      setErrorMessage('La imagen supera los 4MB');
      return true;
    }
    const img = await buildImage(currentFile);
    if (img['width'] < PHOTO_VIGNETTE.MIN_WIDTH || img['height'] < PHOTO_VIGNETTE.MIN_HEIGHT) {
      setErrorMessage(`Tamaño mínimo de imagen: ${PHOTO_VIGNETTE.MIN_WIDTH}x${PHOTO_VIGNETTE.MIN_HEIGHT}`);
      return true;
    }
    return false;
  };

  const buildImage = (currentFile) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = window.URL.createObjectURL(currentFile);
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = objectUrl;
    })
  };

  const handleChange = async (e) => {
    if (isClient) {
      const file = e.target.files[0];
      const isErrorImage = await getValidDimensionImage(file);
      if (!isErrorImage) {
        setIsActionUplod(true);
        dispatch(postPhotoVignette(categoryId, channelId, file));
      }
    }
  };

  const getIsDisplayImage = () => isShowImage && !errorMessage && !isFetching;

  const setExtrachargeByNewspaper = (item, isChecked, quantity) => {
    const group = { 1: [1, 3], 2: [2, 4, 5] };
    const groupBoth = { 1: 2, 2: 1 };
    const currentGroup = group[newspaperId];
    currentGroup.map(channel => {
      if (channel === channelId) {
        dispatch(selectExtracharge(channel, item.extrachargeId, isChecked, quantity));
      } else {
        const beforeItem = extracharges[channel].data.filter(x => x.extrachargeId === item.extrachargeId)[0];
        dispatch(selectExtracharge(channel, item.extrachargeId, beforeItem && beforeItem.checked, quantity));
      }
    })
    if (counterBoth && counterBoth[item.extrachargeId]) {
      const lastNewspaper = groupBoth[newspaperId];
      const alternGroup = group[lastNewspaper];
      alternGroup.map(channel => {
        const beforeItem = extracharges[channel].data.filter(x => x.extrachargeId === item.extrachargeId)[0];
        if (channel === channelId) {
          dispatch(selectExtracharge(channel, item.extrachargeId, isChecked, quantity));
        } else {
          dispatch(selectExtracharge(channel, item.extrachargeId, beforeItem && beforeItem.checked, quantity));
        }
      });
    }
  };

  return (
    <Multimedia ref={refWrapper} height={height}>
      <ImagePreview
        isDisplay={getIsDisplayImage()}
        ref={refImage}
        src={imageDefault || currentPhotoVignette}
      />
      {
        (isFetching) ?
          <Loading><Icon data-name='icon-circle' fill='#ccc' width={'17'} height={'17'} /></Loading>
          :
          (isShowImage && !errorMessage) ?
            isShowIconClose && <IconCloseWrapper color={colorTheme} onClick={handleClickClearImage}>
              <Icon data-name="icon-close-bold" width="14" height="14" fill="#fff" />
            </IconCloseWrapper>
            :
            <React.Fragment>
              <Uploader color={COLORS.GRAY} isDisabled={isDisabled}>
                <input
                  type="file"
                  accept="image/*"
                  autoComplete="off"
                  onChange={handleChange}
                />
                <Icon data-name="icon-camera" width="23" height="23" fill={COLORS.GRAY_DARK} />
                <TextButton>Agregar foto<Price>S/ {pricePhotoVignette}</Price></TextButton>
              </Uploader>
            </React.Fragment>
      }
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      {!isShowImage && !isFetching && !errorMessage && <Info>Peso máximo permitido: 4MB</Info>}
    </Multimedia>
  )
};
